import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUser, faEnvelope, faMapMarkerAlt, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Cliente } from '../types';

interface ClientListModalProps {
  isOpen: boolean;
  onClose: () => void;
  clients: Cliente[];
  onSelectClient: (client: Cliente) => void;
}

export const ClientListModal: React.FC<ClientListModalProps> = ({
  isOpen,
  onClose,
  clients,
  onSelectClient
}) => {
  if (!isOpen) return null;

  const handleClientSelect = (client: Cliente) => {
    onSelectClient(client);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content client-list-modal">
        <div className="modal-header">
          <h2>Clientes Encontrados</h2>
          <button onClick={onClose} className="modal-close-btn" title="Fechar">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        <div className="modal-body">
          {clients.length === 0 ? (
            <div className="no-clients">
              <FontAwesomeIcon icon={faUser} size="3x" className="no-clients-icon" />
              <p>Nenhum cliente encontrado</p>
            </div>
          ) : (
            <div className="clients-list">
              {clients.map((client, index) => (
                <div 
                  key={client.id || index} 
                  className="client-card"
                  onClick={() => handleClientSelect(client)}
                >
                  <div className="client-avatar">
                    <FontAwesomeIcon icon={faUser} size="lg" />
                  </div>
                  
                  <div className="client-info">
                    <h3 className="client-name">
                      {client['name_cliente'] || 'Nome não informado'}
                    </h3>
                    
                    <div className="client-details">
                      <div className="client-detail">
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span>{client['email_cliente'] || 'Email não informado'}</span>
                      </div>
                      
                      {client['end_ciente'] && (
                        <div className="client-detail">
                          <FontAwesomeIcon icon={faMapMarkerAlt} />
                          <span>{client['end_ciente']}</span>
                        </div>
                      )}
                      
                      {client['cidade'] && client['estado'] && (
                        <div className="client-detail">
                          <FontAwesomeIcon icon={faMapMarkerAlt} />
                          <span>{client['cidade']}, {client['estado']}</span>
                        </div>
                      )}
                      
                      {client['cep'] && (
                        <div className="client-detail">
                          <FontAwesomeIcon icon={faMapMarkerAlt} />
                          <span>CEP: {client['cep']}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="client-select">
                    <button className="select-btn">
                      <FontAwesomeIcon icon={faCheck} /> Selecionar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
